import { userContext } from '../userManager';

export const apiSimulationHoldingsOptimization = ({
  varMin,
  varMax,
  targetReturn,
  constraints,
  holdings,
  limit,
}) => {
  return userContext.apiCall({
    url: `/simulations/holdings-optimization`,
    method: 'POST',
    body: { varMin, varMax, targetReturn, constraints, holdings, limit },
  });
};

export const apiSimulationHoldingsKpis = (holdings) => {
  return userContext.apiCall({
    url: `/simulations/holdings-kpis`,
    method: 'POST',
    body: { holdings },
  });
};

export const apiSimulationExpectedFees = ({ startDate, endDate, initialInvestment, holdings }) => {
  return userContext.apiCall({
    url: `/simulations/holdings/expected-fees`,
    method: 'POST',
    body: { startDate, endDate, initialInvestment, holdings },
  });
};

export const apiSimulationInvestmentObjectivesRecommendations = ({
  annualizedReturn,
  targetAmount,
  timeHorizon,
  initialInvestment,
  yearlyReinvestment,
}) => {
  return userContext.apiCall({
    url: `/simulations/investment-objectives/investment-recommendations`,
    method: 'POST',
    body: {
      annualizedReturn: annualizedReturn === 0 ? null : annualizedReturn,
      targetAmount: targetAmount === 0 ? null : targetAmount,
      timeHorizon: timeHorizon === 0 ? null : timeHorizon,
      yearlyReinvestment: yearlyReinvestment === 0 ? null : yearlyReinvestment,
      initialInvestment: initialInvestment === 0 ? null : initialInvestment,
    },
  });
};

export const apiSimulationInvestmentObjectivesForecast = ({
  forecastAnnualMinReturn,
  forecastAnnualMeanReturn,
  forecastAnnualMaxReturn,
  timeHorizon,
  yearlyReinvestment,
  initialInvestment,
}) => {
  return userContext.apiCall({
    url: `/simulations/investment-objectives/investment-forecast`,
    method: 'POST',
    body: {
      forecastAnnualMinReturn,
      forecastAnnualMeanReturn,
      forecastAnnualMaxReturn,
      timeHorizon,
      yearlyReinvestment,
      initialInvestment,
    },
  });
};
